import { Pipe, PipeTransform } from '@angular/core';
import { DepartmentEstimate } from '@interfaces/DepartmentEstimate';

@Pipe({
  name: 'hoursBillableFinal'
})
export class HoursBillableFinalPipe implements PipeTransform {
  public transform(departmentEstimate: DepartmentEstimate): number {
    let hoursBillableFinal = 0;

    for (const line of departmentEstimate.estimateLines) {
      if (line.laborBillableFinal !== null) {
        hoursBillableFinal += line.laborBillableFinal;
      } else {
        for (const classificationLine of line.classificationLines) {
          const hoursBillable = classificationLine.hours * classificationLine.rateBillable;
          hoursBillableFinal += hoursBillable;
        }
      }
    }
    return hoursBillableFinal;
  }
}
